module.exports = __webpack_public_path__ + "static/media/and.4ab8ab6b.svg";